<template>
  <Push noOverlay :isOpen="isOpen">
    <div class="h-32 p-6 pb-0 text-center bg-front-page-background">
      <div class="h-full w-full logo-container"></div>
    </div>
    <div v-if="system.external_data.plan === true" class="border-menu hidden sm:block bg-primary">
      <div class="flex flex-col items-center text-white text-xl">{{ system.title }}</div>
      <div class="flex flex-col items-center">
        <p class="text-white text-xs">Your Plan</p>
        <p v-if="selectedOffice.role === 'Standard'" class="text-white">Guild <strong class="text-guild-plan-green"> STANDARD</strong></p>
        <p v-if="selectedOffice.role === 'Enhanced'" class="text-white">Guild <strong class="text-guild-plan-orange"> ENHANCED</strong></p>
        <p v-if="selectedOffice.role === 'Premium'" class="text-white">Guild <strong class="text-guild-plan-purple"> PREMIUM</strong></p>
        <p v-if="selectedOffice.role === 'Lite'" class="text-white">Guild <strong class="text-guild-plan-lite">LITE</strong></p>
        <p v-if="selectedOffice.role === 'Legacy'" class="text-white">Guild <strong class="text-guild-plan-legacy">LEGACY</strong></p>
      </div>

    </div>
    <div v-if="system.show_title && system.external_data.plan === false" class="border-menu text-center ml-0 hidden sm:block text-xl text-white bg-primary">{{ system.title }}</div>
    <router-link to="/" exact class="border-menu pl-5 text-white no-underline" v-if="system.homepage === null">
      <span>Dashboard</span>
    </router-link>
    <router-link to="/news" class="border-menu pl-5 text-white no-underline" v-if="system.homepage === null && (selectedOffice.permissions && selectedOffice.permissions.includes('referrals only') === false)">
    <span>News</span>
    </router-link>
    <!-- end of system links -->
    <template v-for="menu in displayableMenuItems(menus)">
      <MenuOption
        v-if="displayMenu(menu)"
        :type="menu.type"
        :slug="menu.slug"
        :key="menu.id"
        v-show="((selectedOffice.permissions && selectedOffice.permissions.includes('referrals only') === false) || hasReferralPages(menu)) && hasMenuPermission(menu)"
      >
        <span>{{ menu.name }}</span>
        <i class="fas fa-bell text-yellow-dark" v-if="menu.slug === 'marketing-packs' && marketingPackNotifications.notifications"></i>
        <i
          v-if="menu.children.length > 0 && displayableMenuItems(menu.children).length > 0"
          class="fas mr-1"
          :class="[menu.expanded ? 'fa-chevron-up' : 'fa-chevron-down']"
          @click.stop.prevent="menu.expanded = !menu.expanded"
        />
      </MenuOption>
      <div
        v-if="menu.expanded"
        class="flex flex-col my-0 py-0 w-full overflow-hidden h-auto child-menu"
        :key="menu.id + '-inner'"
      >
        <MenuOption
          v-for="childMenu in displayableMenuItems(menu.children)"
          v-if="displayMenu(childMenu)"
          :key="childMenu.id"
          :type="childMenu.type"
          :slug="childMenu.slug"
          v-show="(selectedOffice.permissions && selectedOffice.permissions.includes('referrals only') === false) || hasReferralPages(menu)"
        >
          <span>{{ childMenu.name }}</span>
        </MenuOption>
      </div>
    </template>
    <!-- <router-link to="/profile" class="border-menu pl-5 text-white no-underline">
      <span>Profile</span>
    </router-link> -->
    <router-link to="/profile-v2" v-if="system.show_profile_menu" class="border-menu pl-5 text-white no-underline">
      <span>Profile</span>
    </router-link>
    <router-link v-if="profile.page_admin && (selectedOffice.permissions && selectedOffice.permissions.includes('referrals only') === false)" to="/admin" class="border-menu pl-5 text-white no-underline">
      <span>Admin</span>
    </router-link>
  </Push>
</template>

<script>
import { find } from 'lodash'
import Push from '@/components/Menu/PushMenu'
import { getBodyDimensions } from '@/helpers'
import { mapState, mapGetters, mapActions } from 'vuex'
import MenuOption from './Menu/MenuOption'

export default {
  components: {
    MenuOption,
    Push
  },

  data () {
    return {
      isOpen: false,
      activeItem: 0
    }
  },

  computed: {
    ...mapState([
      'digitalHubLink',
      'menus',
      'pages',
      'profile',
      'selectedOffice',
      'annualReview',
      'system',
      'marketingPackNotifications'
    ]),

    ...mapGetters(['getMenuPages']),

    hasPartnerPages () {
      return this.pages.filter(page =>
        page.published === 1 && page.type === 'partner' && page.partner_options
      ).length > 0
    },

    hasMarketingPackPages () {
      return this.pages.filter(page =>
        page.published === 1 && page.type === 'marketing-pack'
      ).length > 0
    },

    systemsAvailable () {
      if (!this.system.networks) {
        return []
      }

      let filteredSystem = find(this.system.networks, network => network.id === this.selectedOffice.network_id)

      if (!filteredSystem) {
        return []
      }

      const data = filteredSystem.data.external_data || filteredSystem.data

      return data.systems_available || []
    },

    propertyCmsDisabled () {
      return process.env.VUE_APP_DISABLEPROPERTYCMS === 'true'
    }
  },

  methods: {
    ...mapActions(['fetchMarketingPackNotifications']),
    displayMenu (menu) {
      return (menu.name && menu.type && menu.slug) && (menu.type !== 'FEATURE' || this.hasFeature(menu.slug))
    },

    hasFeature (feature) {
      const featureList = {
        digitalHub: () => this.systemsAvailable.indexOf('digital-hub') !== -1 && this.digitalHubLink,
        insight: () => this.systemsAvailable.indexOf('insight') !== -1,
        knowledgeHub: () => this.systemsAvailable.indexOf('knowledge-hub') !== -1,
        'marketing-packs': () => this.hasMarketingPackPages,
        partnerPages: () => this.hasPartnerPages,
        pom: () => this.selectedOffice.id && this.systemsAvailable.indexOf('pom') !== -1,
        propertyCms: () => !this.propertyCmsDisabled,
        propertyFeeds: () => !this.propertyCmsDisabled,
        webinars: () => this.systemsAvailable.indexOf('knowledge-hub') !== -1,
        annualReview: () => this.annualReview && this.systemsAvailable.indexOf('annual-review') !== -1 && this.profile.type.toString() === '1',
        websiteCms: () => this.selectedOffice.id && this.systemsAvailable.indexOf('websites') !== -1,
        qrGenerator: () => this.selectedOffice.id && this.systemsAvailable.indexOf('qr-generator') !== -1,
        eventsBookedBy: () => this.selectedOffice.id && this.systemsAvailable.indexOf('events-booked-by-me') !== -1,
        eventsBookedFor: () => this.selectedOffice.id && this.systemsAvailable.indexOf('events-booked-for-me') !== -1
      }

      if (featureList[feature]) {
        return featureList[feature]()
      }

      return false
    },

    displayableMenuItems (menus) {
      if (this.selectedOffice.role === 'Lite') {
        return menus.filter(m => {
          return m.type !== 'PAGE' || this.getMenuPages(m).length > 0
        }).filter(this.displayMenu).filter(m => {
          return m.guild_lite === true
        })
      }
      return menus.filter(m => {
        return m.type !== 'PAGE' || this.getMenuPages(m).length > 0
      }).filter(this.displayMenu)
    },
    hasReferralPages (menu) {
      return this.getMenuPages(menu).filter(p => {
        return p.product_module && p.product_module.includes('App\\Members\\ProductModules\\ReferralsModule')
      }).length > 0
    },
    hasCompletionReportPages (menu) {
      const pages = this.getMenuPages(menu)
      return pages.length <= 1 && pages.filter(p => {
        return p.product_module && p.product_module.includes('App\\Members\\ProductModules\\CompletionReportModule')
      }).length > 0
    },
    hasMenuPermission (menu) {
      if (this.hasCompletionReportPages(menu) && !this.selectedOffice.permissions.includes('access completion reports')) {
        return false
      }
      if ([7, 8].includes(this.selectedOffice.network_id) && menu.assigned_countries.length > 0 && menu.assigned_countries.includes('UKA')) {
        return (menu.assigned_network === this.selectedOffice.network_id || menu.assigned_network == null) && (this.selectedOffice.associate === true || menu.assigned_countries.includes(this.selectedOffice.country))
      } else if ([7, 8].includes(this.selectedOffice.network_id) && menu.assigned_countries.length > 0) {
        return (menu.assigned_network === this.selectedOffice.network_id || menu.assigned_network == null) && (menu.assigned_countries.includes(this.selectedOffice.country))
      }
      return menu.assigned_network === this.selectedOffice.network_id || menu.assigned_network == null
    },

    ...mapActions(['displayToastNotification', 'setActiveChildMenu'])
  },

  mounted () {
    let { width } = getBodyDimensions()
    if (width >= 992) {
      this.isOpen = true
    } else {
      this.isOpen = false
    }
  },

  watch: {
    menus () {
      this.setActiveChildMenu(this.$route.params.menuSlug)
    },
    '$route': function (route) {
      this.setActiveChildMenu(route.params.menuSlug)
    },
    selectedOffice () {
      if (this.hasMarketingPackPages) {
        this.fetchMarketingPackNotifications()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.bm-item-list {
  margin-left: 0%;
}
.bm-item-list {
  > * {
    span {
      font-weight: normal;
    }
  }
}
.border-menu {
  position: relative;
  &::after {
    position: absolute;
    left: 1.1rem;
    right: 1.1rem;
    bottom: 0px;
    content: '';
    border-bottom: 1px solid #FFF;
    opacity: 0.25;
  }
  &.router-link-active {
    &::after {
      left: 12px;
    }
  }

  &:first-child, &:last-of-type {
    &::after {
      left: 0px;
      right: 0px;
    }
  }
}
.cross-style {
  position: absolute;
  top: 12px;
  left: 12px;
  cursor: pointer;
}
.bm-burger-button {
  top: 18px;
}
@media screen and (min-width: 576px) {
  .fit-page {
    width: calc(100% - 18rem);
  }
}
</style>
